/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InformationExtractionSchemaFieldType } from './InformationExtractionSchemaFieldType';
import {
  InformationExtractionSchemaFieldTypeFromJSON,
  InformationExtractionSchemaFieldTypeFromJSONTyped,
  InformationExtractionSchemaFieldTypeToJSON,
} from './InformationExtractionSchemaFieldType';

/**
 *
 * @export
 * @interface ConversationalAgentStateField
 */
export interface ConversationalAgentStateField {
  /**
   *
   * @type {string}
   * @memberof ConversationalAgentStateField
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof ConversationalAgentStateField
   */
  description: string;
  /**
   *
   * @type {boolean}
   * @memberof ConversationalAgentStateField
   */
  exactMatch?: boolean;
  /**
   *
   * @type {InformationExtractionSchemaFieldType}
   * @memberof ConversationalAgentStateField
   */
  type: InformationExtractionSchemaFieldType;
}

/**
 * Check if a given object implements the ConversationalAgentStateField interface.
 */
export function instanceOfConversationalAgentStateField(value: object): value is ConversationalAgentStateField {
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('description' in value) || value['description'] === undefined) return false;
  if (!('type' in value) || value['type'] === undefined) return false;
  return true;
}

export function ConversationalAgentStateFieldFromJSON(json: any): ConversationalAgentStateField {
  return ConversationalAgentStateFieldFromJSONTyped(json, false);
}

export function ConversationalAgentStateFieldFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ConversationalAgentStateField {
  if (json == null) {
    return json;
  }
  return {
    name: json['name'],
    description: json['description'],
    exactMatch: json['exact_match'] == null ? undefined : json['exact_match'],
    type: InformationExtractionSchemaFieldTypeFromJSON(json['type']),
  };
}

export function ConversationalAgentStateFieldToJSON(value?: ConversationalAgentStateField | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    description: value['description'],
    exact_match: value['exactMatch'],
    type: InformationExtractionSchemaFieldTypeToJSON(value['type']),
  };
}
